import React from 'react';
import { ServiceManager } from '@jutro/legacy/services';
import { CurrencyField } from '@jutro/legacy/components';

function Currency(props) {
    const localeService = ServiceManager.getService('locale-service');
    return (
        <CurrencyField
            {...props}
            defaultCurrency={localeService.getDefaultCurrencyCode()}
        />
    );
}

Currency.propTypes = CurrencyField.propTypes;
Currency.defaultProps = CurrencyField.defaultProps;

export default Currency;
